var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookThumb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.24005 0 0 4.95169 0 11.64C0 15.1385 1.43376 18.1615 3.76868 20.2496C3.96469 20.425 4.08301 20.6708 4.09105 20.9338L4.1564 23.0684C4.17728 23.7492 4.88058 24.1923 5.50362 23.9172L7.88545 22.8658C8.08737 22.7768 8.31362 22.7602 8.52638 22.8188C9.6209 23.1197 10.7858 23.28 12 23.28C18.76 23.28 24 18.3284 24 11.64C24 4.95169 18.76 0 12 0Z",
    fill: "url(#paint0_radial_5644_9367)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7943 15.0441L8.31931 9.45166C8.88002 8.56198 10.0807 8.34046 10.9221 8.97142L13.7257 11.0741C13.9829 11.2671 14.3368 11.2661 14.593 11.0717L18.3794 8.19802C18.8848 7.8145 19.5445 8.4193 19.2063 8.95601L15.6813 14.5485C15.1205 15.4382 13.9198 15.6598 13.0785 15.0287L10.2748 12.926C10.0176 12.7331 9.66367 12.7341 9.40754 12.9285L5.6211 15.8021C5.11573 16.1856 4.45602 15.5808 4.7943 15.0441Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5644_9367",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.61939 23.8716) scale(26.1503 26.1503)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609754,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934823,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookThumb);
export default __webpack_public_path__ + "static/media/facebook_thumb.cffed07f5da38d5ba405880e1b353044.svg";
export { ForwardRef as ReactComponent };